import {
  _getCaptchaBase64,
  _sendLogin,
  _validateCaptcha,
  _sendPasRes,
  _getPhoneMessage
} from '@/api/UserLogin'
import {
  catchErr,
  PMSLIST
} from '@/utils/utils'
import {
  Message
} from 'element-ui'
import {
  sendLoginOut
} from '@/store/modules/Common/actions'
import router from '@/router'


function roleJurisdiction(pms,didLogined) {
  var path = "";
  if(pms["10000"].check) {
      path = "/statistics"
  } else if(pms["20000"].check) {
      path = "/unit"
  } else if(pms["30000"].check) {
      path = "/permission"
  } else if(pms["40000"].check) {
      path = "/operation"
  } else if(pms["50000"].check) {
      path = "/space"
  } else if(pms["60000"].check) {
      path = "/user"
  } else if(pms["70000"].check) {
      path = "/order"
  } else {
      path = "/nopms"
  }
  if(didLogined) {
    window.sessionStorage.setItem('goingto',path)
    window.location.reload()
  } else {
    router.push({
      path: path
    });
  }
  
}

async function getCaptchaBase64Run({
  commit,
  state
}) {
  let [err, res] = await catchErr(_getCaptchaBase64());
  if (err) {
    Message.error(err || '错了哦，系统异常');
  } else if (res) {
    commit('SETIMGCODEPATH', res.data);
  }
}

export default {
  async getCaptchaBase64({
    commit,
    state
  }) {
    getCaptchaBase64Run({
      commit,
      state
    });
  },
  async sendLogin({
    commit,
    state
  }, parmas = state.ruleForm) {
    if(state.logining) {
      return
    }
    commit('SETOPTIONS', {
      logining: true
    });
    // let [err, res] = await catchErr(_validateCaptcha({
    //   data: parmas.baseReqDto.toLowerCase()
    // }));
    // if (err) {
    //   Message.error('图形验证码错误');
    //   commit('SETOPTIONS', {
    //     logining: false
    //   });
    //   getCaptchaBase64Run({
    //     commit,
    //     state
    //   }); //重置验证码
    //   return false;
    // }
    let [err_login, res_login] = await catchErr(_sendLogin({
      name: parmas.account,
      pwd: parmas.pwd,
      smsCode: parmas.message,
      smsTel: parmas.phone
    }));
    if (err_login) {
      if(err_login.status == 1019) {
        Message.error("短信验证码错误")
      } else if (err_login.status == 1018) {
        Message.error("短信验证码已失效");
      } else {
        Message.error(err_login);
      }
      commit('SETOPTIONS', {
        binyi_cms_loginInfo: {
          role: {}
        },
        logining: false
      });
      window.sessionStorage.setItem("binyi_cms_loginInfo", "");
      // getCaptchaBase64Run({
      //   commit,
      //   state
      // }); //重置验证码
    } else if (res_login) {
      console.log(res_login)
      let userInfo;
      try {
        userInfo = JSON.stringify(res_login.data)
      } catch (error) {
        userInfo = "";
      }
      commit('SETOPTIONS', {
        ruleForm: {
          unit: "",
          account: "",
          pwd: "",
          baseReqDto: ""
        },
        binyi_cms_loginInfo: res_login.data,
        logining: false
      });
      window.sessionStorage.setItem("binyi_cms_loginInfo", userInfo);
      window.localStorage.setItem("zgjs_login_id", res_login.data.id);

      let userData = res_login.data;
      let allPms = JSON.parse(JSON.stringify(PMSLIST));
      if (userData.validateRole) {
        userData.role.menus.forEach(item => {
          let idStr = item.id.toString();
          if(Object.keys(allPms).indexOf(idStr) >= 0) {
            allPms[idStr].check = true;
          }
          
        })

      } else {
        Object.keys(allPms).forEach(item => {
          if( allPms[item].adminPms) {
            allPms[item].check = true
          }
          
        })
      }
      window.sessionStorage.setItem("binyi_cms_pms", JSON.stringify(allPms));
     
      if(state.loginSucceed) {
        roleJurisdiction(allPms,true);
      } else {
        commit('SETOPTIONS', {
          loginSucceed: true
        });
        roleJurisdiction(allPms,false);
        
      }
    } else {
      commit('SETOPTIONS', {
        logining: false
      });
    }
  },


  async sendPasRes({
    commit,
    state
  }, parmas = state.pasResForm) {
    if (parmas.adminId == 0) {
      if (state.binyi_cms_loginInfo.reset) {
        commit('SETOPTIONS', {
          binyi_cms_loginInfo: {
            role: {}
          },
          ruleForm: {
            unit: "",
            account: "",
            pwd: "",
            baseReqDto: ""
          },
          pasResForm: {
            "adminId": 0,
            "oldPwd": "",
            "newPwd": ""
          }
        });
        sendLoginOut({
          commit,
          state
        });
      } else {
        router.go(-1);
      }
      return;
    }
    let [err, res] = await catchErr(_sendPasRes({
      data: parmas
    }));
    if (err) {
      Message.error(err || '错了哦，系统异常');
    } else if (res) {
      if(res.status == 1000) {
        commit('SETOPTIONS', {
          binyi_cms_loginInfo: {
            role: {}
          },
          ruleForm: {
            unit: "",
            account: "",
            pwd: "",
            baseReqDto: ""
          },
          pasResForm: {
            "adminId": 0,
            "oldPwd": "",
            "newPwd": ""
          }
        });
        Message.success("操作成功")
        sendLoginOut({
          commit,
          state
        });
      } else {
        Message.error(res.message | "系统异常")
      }

    }
    return;
  },

  getLoginInfo({
    commit,
    state
  }) {
    let loginInfo = window.sessionStorage.getItem("binyi_cms_loginInfo");
    try {
      if (!loginInfo) {
        window.sessionStorage.clear();
        router.replace({
          path: "/userlogin"
        });
      } else {
        let binyi_cms_loginInfo = JSON.parse(loginInfo);
        commit('SETOPTIONS', {
          binyi_cms_loginInfo
        });
      }
    } catch (error) {
      window.sessionStorage.clear();
      router.replace({
        path: "/userlogin"
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/UserLogin/actions.js